module.exports = {"private":true,"main":"./oauthApplication.js"}


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/actions/oauthApplication/package.json
// module id = 829
// module chunks = 0 1